<template>
  <div class="osh-balance-information">
    <information button-title="לבניית התזרים" :button-action="next"
                 animation-name="osh-balance.json">
      <template v-slot:information-title>
        <div>
          <span>אם נסיים את החודש בתזרים חיובי,</span>
          <span v-if="positiveBalance">נגדיל את יתרת העו״ש שלנו!</span>
          <span v-else>נתחיל לסגור את המינוס!</span>
        </div>

      </template>
      <template v-slot:information-description>
        <div>
          <div v-if="balance" class="text-block">
            <div>
              <span>כרגע מצב העו״ש שלך עומד על</span>
              <span class="balance">{{balance}}</span>
              <span>₪</span>
            </div>
          </div>
          <div class="text-block">
            מיד המערכת תבנה לך תזרים ראשון, ונציג לך בדיוק כמה נשאר להוציא עד סוף החודש.
          </div>
          <div class="text-block">
            <div>החודש הסתיים בתזרים חיובי?</div>
            <div class="bold">שמת כסף בצד והגדלת את היתרה בעו״ש.</div>
          </div>
        </div>
      </template>
    </information>
  </div>
</template>
<script>

import { mapActions, mapMutations, mapState } from 'vuex';
import Information from './components/Information';
import Segment from '../../../../../Segment';

export default {
  components: {
    Information,
  },
  name: 'OshBalanceInformationNew',
  async created() {
    this.init();
    Segment.trackUserGot('OBbalancestateenteredNew');
  },
  computed: {
    ...mapState('balance', ['balances']),
    positiveBalance() {
      if (this.balances.length === 1) {
        return this.balances[0].balance >= 0;
      }
      return null;
    },
    balance() {
      if (this.balances.length === 1) {
        return this.balances[0].balance;
      }
      return null;
    },
  },
  methods: {
    ...mapMutations('onboardingState', ['setMonthReview']),
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    ...mapActions('balance', ['init']),
    next() {
      this.onboardingPageSubmit();
      Segment.trackUserInteraction('OBbalancestatenextclicked');
    },
  },
};
</script>

<style lang="scss">
@import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

.osh-balance-information {
  height: 100%;

  .text-block {
    margin-bottom: 20px;

    .balance{
      direction: ltr;
      display: inline-block;
    }
  }

  .information {

    .body {
      background-color: $riseup_beige;
    }

    img {
      background-color: $riseup_beige;
    }

    lottie-player {
      background-color: $riseup_beige;
    }
  }
}

</style>
